import { EffectsMapObject } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";
import { CoreEffects, CoreReducers, CoreState } from "@reco-m/core";
import { app } from "@reco-w/core-ui";

import { IS_GET_ORDER_ON_HEADER } from "@reco-w/common-common";
import { Namespaces as commonNamespaces } from "@reco-w/common-models";
import { marketService } from "@reco-w/market-service";

import { Namespaces } from "./common";

export namespace mymenuModel {
    export const namespace = Namespaces.myMenu;

    export const state: any = freeze({
        ...CoreState,
    });
    export type StateType = typeof state;

    export const reducers: ReducersMapObject = {
        ...CoreReducers,
        initState() {
            return state;
        },
    };

    export const effects: EffectsMapObject = {
        ...CoreEffects,

        *initPage({ message }, { call, put }) {
            put({ type: "showLoading" });
            try {
                yield put({ type: "getCertify", message, isgetOrder: IS_GET_ORDER_ON_HEADER });
                yield put({ type: "getNotification", message });
            } catch (e) {
                yield call(message!.error, "Menu-initPage：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },

        *getCertify({ message, isgetOrder, isRefreshUser }, { call, put, select }) {
            try {
                yield yield put({ type: `${commonNamespaces.memberCommon}/getCertify`, isRefreshUser, message });
                const memberCommonState: any = yield select((state) => state[commonNamespaces.memberCommon]),
                    user = memberCommonState.user,
                    member = memberCommonState.member;
                // certifyDetail = memberCommonState.get("certifyDetail");
                yield put({ type: "input", data: { member: member?.id ? member : null, user } });

                if (isgetOrder) {
                    yield put({ type: "getInstitution", companyId: member && member.companyId, message });
                    yield put({ type: "getCheckInDetail", userId: user?.currentUser?.id, message });
                }
            } catch (e) {
                yield call(message!.error, "Menu-getCertify" + e.errmsg);
            }
        },
        *getCheckInDetail({ data, message, userId }, { call, put, select }) {
            try {
                yield yield put({ type: `${commonNamespaces.workorderCommon}/getCheckInDetail`, data, userId, message });
                const workorderCommonState: any = yield select((state) => state[commonNamespaces.workorderCommon]),
                    checkInData = workorderCommonState.checkInData;

                const checkOrderId = checkInData?.isCheckCancel ? checkInData?.checkOrderId : null,
                    checkStateId = checkInData?.isCheckCancel ? checkInData?.checkStateId : null;

                yield put({ type: "input", data: { checkInData, checkOrderId, checkStateId } });
            } catch (e) {
                yield call(message!.error, "Menu-getCheckInDetail" + e.errmsg);
            }
        },

        *getInstitution({ message }, { call, put }) {
            try {
                const result = yield call(marketService.getMyInstitution);

                yield put({ type: "input", data: { institution: result } });
            } catch (e) {
                yield call(message!.error, "Menu-getInstitution" + e.errmsg);
            }
        },

        /**
         * 获取消息
         * @param { message }
         * @param { call, put, select }
         */
        *getNotification({ message }, { call, put, select }) {
            try {
                yield yield put({ type: `${commonNamespaces.noticeCommon}/getUnreadNotification`, message });
                const noticeCommonState = yield select((state) => state[commonNamespaces.noticeCommon]),
                    noticeCount = noticeCommonState!.noticeCount;

                yield put({ type: "input", data: { noticeCount } });
            } catch (e) {
                yield call(message!.error, "getNotification：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },
    };
}

export function registerMyMenuModel(model?: any) {
    app.model(model || mymenuModel);
}
